<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">仓储订单详情</div>
      <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">订单号：{{orderDetail.order_id}} </h2>
          <h2 class="weui-msg__title">{{order_status()}}</h2>
          <div class="notice-yellow" v-if="orderDetail.pay_status==0">请在{{orderDetail.expiration_time| moment("HH点mm分")}}前完成支付，否则订单将失效</div>
      </div>

      <div class="weui-cells__title">套餐价格</div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>每周费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.storage_scale_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>存储周数</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.estimated_week}}周</div>
        </a>
      </div>
      <div class="weui-cells__title" v-if="subDetail.length>0">取货 /送回 订单</div>

      <div class="weui-cells" v-if="subDetail.length>0">
        <a class="weui-cell" href="javascript:;"  v-for="item in subDetail">
            <div class="weui-cell__bd">
                <p>{{item.type_name}}</p>
            </div>

            <div class="weui-cell__ft">
              <span class="color-orange" v-if="1"><router-link :to="subLink(item.order_number)">点击查看子订单</router-link></span>
              <span v-else>尚未安排行程</span>
            </div>
        </a>
      </div>

      <div class="weui-cells__title">服务详情</div>

      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>联系方式</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.member_name + " " + orderDetail.member_phone}}</div>
        </a>

      </div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>入库方式</p>
            </div>
            <div class="weui-cell__ft" v-if="orderDetail.details.ifSelfPick==1">自行送往 - {{orderDetail.details.warehouse}} 仓库</div>
            <div class="weui-cell__ft" v-if="orderDetail.details.ifSelfPick==0">到家上门取货</div>
        </a>
        <a class="weui-cell " href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.pick_date | moment("YYYY年M月D日")}} {{pick_period}}</div>
        </a>
        <a v-if="orderDetail.details.ifSelfPick=='0'" class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>取货地址</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.pick_address.pick_street}}, {{orderDetail.details.pick_address.pick_suburb}}, {{orderDetail.details.pick_address.pick_state}}, {{orderDetail.details.pick_address.pick_postcode}}</div>
        </a>
      </div>
      <div class="weui-cells">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>出库方式</p>
            </div>
            <div class="weui-cell__ft" v-if="orderDetail.details.ifSelfReturn==1">自行取回 - {{orderDetail.details.warehouse}} 仓库</div>
            <div class="weui-cell__ft" v-if="orderDetail.details.ifSelfReturn==0">到家上门送回</div>
        </a>

        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft" v-if="orderDetail.details.return_time_pending=='0'">{{orderDetail.details.return_date | moment("YYYY年M月D日")}} {{return_period}}</div>
            <div class="weui-cell__ft" v-else>待定，{{orderDetail.details.return_time_pending=="0" ? orderDetail.details.cal_week : orderDetail.details.estimated_week}}周后送回前再确定</div>
        </a>

        <a v-if="orderDetail.details.return_addr_pending=='0' && orderDetail.details.ifSelfReturn=='0'" class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.return_address.return_street}}, {{orderDetail.details.return_address.return_suburb}}, {{orderDetail.details.return_address.return_state}}, {{orderDetail.details.return_address.return_postcode}}</div>
        </a>
        <a v-if="orderDetail.details.return_addr_pending=='1' && orderDetail.details.ifSelfReturn=='0'" class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">待定，送回前确定</div>
        </a>
        <a v-if="orderDetail.details.return_addr_pending=='2' && orderDetail.details.ifSelfReturn=='0'" class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>送回地址</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.return_street}}, {{orderDetail.details.return_suburb}}, {{orderDetail.details.return_state}}, {{orderDetail.details.return_postcode}}</div>
        </a>

      </div>




      <div v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <br>
      </div>
      
      <div class="btn-box" v-if="orderDetail.pay_status==1||orderDetail.pay_status==3||orderDetail.pay_status==4||orderDetail.pay_status==5">
        <div class="btn active" @click="goback()">返回</div>
      </div>
      

      <div class="btn-box-fix" v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <div class="btn-container">
          <div class="btn active" @click="checkSubmit()">立即支付</div>
        </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>

      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取订单</p>
              </div>
          </div>
      </transition>

      <div class="js_dialog" v-show="isLeaving">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">尚未完成支付</strong></div>
              <div class="weui-dialog__bd">确定要离开订单详情页吗？离开后需要登录账号才可以完成支付</div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="goto('/login')">离开</a>
                  <div  class="weui-dialog__btn weui-dialog__btn_daojia" @click="checkSubmit()">立即支付</div>
              </div>
          </div>
      </div>


    </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      subDetail:{},
      orderDetail:{
        "order_id": "",
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "gst_amount": "",
        "cancelfee_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": "",
        "other_amount_data": "",
        "invoices_url": "",
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
            "operates_num": 0
        },
        "details": {
            "student_plan": "",
            "baggage": "",
            "pick_address": {
                "pick_street": "",
                "pick_suburb": "",
                "pick_state": "",
                "pick_postcode": ""
            },
            "pick_date": "",
            "pick_time": "",
            "pick_period": "",
            "return_address": {
                "return_street": "",
                "return_suburb": "",
                "return_state": "",
                "return_postcode": ""
            },
            "return_date": "",
            "return_time": "",
            "return_period": "",
            "contact_bak": "",
            "return_pending": "",
            "student_plan_name": ""
        },
        "expiration_time": 0,
        "lifecycle_text": "",
        "lifecycle_status": 0
      }
    }
  },
  methods: {
    order_status: function () {
      let result = '';
      switch (this.orderDetail.pay_status) {
        case "0":
          result = '订单已确认，待支付定金 $'+this.orderDetail.deposit_amount;
          break;
        case "1":
          result = '已付定金，等待服务'
          break;
        case "2":
          result = '服务完毕，待支付全款'
          break;
        case "3":
          result = '已付款，等待确认到账'
          break;
        case "4":
          result = '已付款完毕，感谢使用我们的服务'
          break;
        case "5":
          result = '已退款'
          break;
        default:
          console.log("订单状态异常");
      }
      return result;
    },
    subLink: function (id){
      return "/warehouse/order-detail-sub?id="+id;
    },
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            if(that.orderDetail.lifecycle_status==1){
              that.$router.push('/order-cancel?reason=timeout');
            }
            if(that.orderDetail.order_status==8){
              that.$router.push('/order-cancel');
            }
            if(that.orderDetail.pay_status==0||that.orderDetail.pay_status==1){
            }
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            else{
              that.$router.push('/warehouse/order-detail-sub?id='+that.$route.query.id)
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });

        this.axios.post(this.apiURL()+'/Order/storageList', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.subDetail = response.data.data;
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    checkSubmit(){
      if(this.orderDetail.pay_status==0){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&status=0&amount='+this.depositAmount());
      }
    },
    goback(){
      if(this.orderDetail.pay_status==0&&!localStorage.token){
        this.isLeaving = true;
      }
      else{
        this.$router.push('/order');
      }
    },
  },
  components: {
  },
  computed: {
    orderIDFromURL: function (){
      let theString = this.$route.query.id;
      if(theString.includes("?")){
        return theString.substring(0, theString.indexOf('?'));
      }
      else{
        return theString;
      }
    },
    pick_period: function () {
      let result = '';
      switch (this.orderDetail.details.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.orderDetail.details.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    pricing: function () {
      let result = '';
      switch (this.orderDetail.details.student_plan) {
        case "1668743923":
          result = '298'
          break;
        case "1668743953":
          result = '428'
          break;
        case "1668743985":
          result = '568'
          break;
        case "1668744048":
          result = '688'
          break;
        default:
          console.log("1");
      }
      return result;
    },

  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/warehouse/order-detail.vue